import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { c_dtable_app_users_sites_list_module } from "src/3ui/2components/dtable/app-users/app_users_sites_list/c_dtable_app_users_sites_list_module";

import { c_dialog_add_app_users_component } from "./c_dialog_add_app_users_component";

@NgModule({
  imports: [CommonModule, FormsModule, MatCheckboxModule, MatSlideToggleModule, c_dtable_app_users_sites_list_module],
  declarations: [c_dialog_add_app_users_component],
})
export class c_dialog_add_app_users_module {}
